import React from 'react'
import { PlanProvider } from './plan.context'
import Plans from './plans'

function PlanModule() {
  return (
    <PlanProvider>
      <Plans />
    </PlanProvider>
  )
}

export default PlanModule
